export const findPermission = (permissions, key) => permissions?.includes(key)
